import { PureComponent, ReactNode } from 'react';
import { GeniePadElementsSettingItem } from '../../../api/pushGenie';
import ElementsConfigureTable from '../../prescriptionPad/rightPanel/workspace/padV2/ElementsConfigureTable';

interface Props<T> {
    title: string;
    configTableTitle: string;
    closeMe: () => void;
    onUpdate: (config: T[]) => void;
    config: T[];
}

type State<T> = {
    elements: T[];
};

class CongigureElemtsTableDialog<T extends GeniePadElementsSettingItem> extends PureComponent<
    Props<T>,
    State<T>
> {
    state: State<T> = {
        elements: this.props.config,
    };
    onSave = (): void => {
        const { closeMe, onUpdate } = this.props;
        const { elements } = this.state;
        onUpdate(elements);
        closeMe();
    };

    updateElemets = (elements: T[]): void => {
        this.setState({ elements });
    };

    componentDidUpdate = (prevProps: Props<T>): void => {
        if (prevProps.config !== this.props.config) {
            this.setState({ elements: this.props.config });
        }
    };

    render(): ReactNode {
        const { configTableTitle, title, closeMe } = this.props;
        const { elements } = this.state;

        return (
            <div className="flex flex-col h-full space-between">
                <div className="flex items-center space-x-16 p-16 cursor-pointer">
                    <div onClick={closeMe} className="flex items-center justify-center w-16 h-16">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className="w-16 h-16 fill-darwin-neutral-1000"
                        >
                            <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                        </svg>
                    </div>
                    <p className="text-14 font-700 leading-5 bold text-neutral-1">{title}</p>
                </div>
                <div className="p-16 flex flex-col flex-1 space-y-16 h-full overflow-auto">
                    <div className="rounded-8 bg-white space-y-8">
                        <p className="text-14 font-700 leading-5 bold text-neutral-1 mb-16">
                            {configTableTitle}
                        </p>
                        <ElementsConfigureTable config={elements} onUpdate={this.updateElemets} />
                    </div>
                </div>

                <div className="flex items-center justify-between px-16 py-8 space-x-8 border-t border-neutral-7">
                    <div>
                        <button onClick={closeMe} className="neutral-btn btn--small px-16 py-8">
                            <span className="w-full text-center">Cancel</span>
                        </button>
                    </div>
                    <div>
                        <button
                            onClick={this.onSave}
                            className="px-12 rounded-8 py-8 btn btn--small bg-darwin-accent-bright-blue-800 space-x-8"
                        >
                            <span className="w-full text-white text-center">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CongigureElemtsTableDialog;
